import React, { useEffect, useState } from 'react';
import { useAnalysisWebSocket } from 'hooks/useAnalysisWebSocket';
import { useFaviconBadge } from 'hooks/useFaviconBadge';
import { ComparisonGrid } from 'components/grid/ComparisonGrid';
import { HistoryView } from 'components/history/HistoryView';
import { CompareView } from 'components/compare/CompareView';
import { UsersView } from 'components/admin/UsersView';
import { LoginScreen } from 'components/auth/LoginScreen';
import { AppTopBar, type AppView } from 'components/layout/AppTopBar';
import { useAuthStore } from 'store/useAuthStore';

export default function App() {
	// Single persistent analysis WebSocket connection for the whole app.
	useAnalysisWebSocket();
	// Reflect manual-analysis progress in the favicon dot (amber → green/red).
	useFaviconBadge();

	const status = useAuthStore((s) => s.status);
	const bootstrap = useAuthStore((s) => s.bootstrap);
	const [view, setView] = useState<AppView>('comparison');

	// Resolve any stored session on mount.
	useEffect(() => {
		void bootstrap();
	}, [bootstrap]);

	if (status === 'unknown') {
		return <div className='app-boot'>Loading…</div>;
	}

	if (status !== 'authenticated') {
		return <LoginScreen />;
	}

	return (
		<>
			<AppTopBar view={view} onChangeView={setView} />
			{view === 'comparison' && <ComparisonGrid />}
			{view === 'history' && <HistoryView />}
			{view === 'compare' && <CompareView />}
			{view === 'users' && <UsersView />}
		</>
	);
}
